import { useState } from 'react'
import { voidInvoice } from '@/api/invoices'
import { Button } from '@/components/ui/button'
import { getApiErrorMessage } from '@/lib/apiError'
import { getVoidInvoiceConfirmMessage } from '@/lib/invoice'
import type { InvoiceDetail } from '@/api/types'

const VOID_LABEL = 'Makulera faktura'
const VOID_ERROR_MESSAGE = 'Kunde inte makulera fakturan just nu. Försök igen.'

interface InvoiceVoidActionProps {
  invoice: InvoiceDetail
  onVoided: (invoice: InvoiceDetail) => void
}

export function InvoiceVoidAction({ invoice, onVoided }: InvoiceVoidActionProps): React.ReactElement {
  const [isVoiding, setIsVoiding] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  const handleVoid = async (): Promise<void> => {
    if (!window.confirm(getVoidInvoiceConfirmMessage(invoice))) {
      return
    }

    setIsVoiding(true)
    setErrorMessage(null)

    try {
      onVoided(await voidInvoice(invoice.id))
    } catch (error) {
      setErrorMessage(getApiErrorMessage(error, VOID_ERROR_MESSAGE))
    } finally {
      setIsVoiding(false)
    }
  }

  return (
    <div className="flex flex-col items-end gap-2">
      <Button
        variant="destructive"
        className="rounded-none"
        disabled={isVoiding}
        onClick={handleVoid}
      >
        {VOID_LABEL}
      </Button>
      {errorMessage && <p className="text-sm text-destructive">{errorMessage}</p>}
    </div>
  )
}
